import React, { useMemo } from 'react';
import { CHILD_AGE_PLACEHOLDER, BED_REQUIRED_ENUM } from '../../../Constant/constants';

const MAX_CHILD_AGE = 12;
const ALLOWED_AGES = Array(MAX_CHILD_AGE + 1)
  .fill(CHILD_AGE_PLACEHOLDER)
  .map((n, index) => (index === 0 ? n : index - 1));
const AddChildrenAge = ({
  ages,
  handleChange,
  paxConfig,
  bedRequired,
  handleBedRequiredChange,
}) => {
  const childBedRequired = useMemo(() => {
    const temp = [];
    ages.forEach((age, index) => {
      if (age === CHILD_AGE_PLACEHOLDER) {
        temp[index] = BED_REQUIRED_ENUM.Yes;
      } else {
        temp[index] = bedRequired[index];
      }
    });
    return temp;
  }, [ages, bedRequired]);
  const handleAgeChange = (index, value) => {
    const updatedAges = ages.map((age, i) => (i === index ? value : age));
    handleChange(updatedAges, childBedRequired);
  };
  const handleBedChange = (index, value) => {
    const updatedBeds = childBedRequired.map((bed, i) => (i === index ? value : bed));
    handleBedRequiredChange(updatedBeds);
  };
  return (
    <ul
      className="children-age_container"
      style={{ flexDirection: paxConfig?.childWithBed ? 'column' : 'row' }}
    >
      {ages.map((age, index) => (
        <div className="child-age-bed" key={index}>
          <li key={`${age}_${index}`}>
            <span className="children-age_title">{`CHILD ${index + 1} AGE`}</span>
            <div>
              <select
                placeholder="Age"
                id="child-age-select"
                value={age}
                onChange={event => handleAgeChange(index, Number(event.target.value))}
              >
                {ALLOWED_AGES.map(num => (
                  <option value={num} key={num} id={`child-age-${num}`}>
                    {num}
                  </option>
                ))}
              </select>
            </div>
          </li>
          {paxConfig?.childWithBed &&
            age >= paxConfig?.minChildAge &&
            age <= paxConfig?.maxChildAge && (
              <li key={`${index}_${age}`}>
                <span className="children-age_title">BED REQUIRED</span>
                <div className="bed-required">
                  <select
                    value={childBedRequired[index]}
                    onChange={event => handleBedChange(index, event.target.value)}
                  >
                    <option value="Yes">{BED_REQUIRED_ENUM.Yes}</option>
                    <option value="No">{BED_REQUIRED_ENUM.No}</option>
                  </select>
                </div>
              </li>
            )}
        </div>
      ))}
    </ul>
  );
};

export default AddChildrenAge;
